import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Select desire icons from icon packages.
 */
import {
  faGift,
  faTachometerAlt,
  faUserEdit,
  faEdit,
  faList,
  faBookOpen,
  faUpload,
  faCog,
  faLink,
  faCamera,
  faFileAlt,
  faExpandArrowsAlt,
  faArrowsAlt,
  faExternalLinkAlt,
  faAngleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faStore,
  faHistory,
  faEnvelope,
  faMoneyBill,
  faHeartbeat,
  faDatabase,
  faShoppingCart,
  faDownload,
  faHome,
  faLayerGroup,
  faFire,
  faPoll,
  faImages,
  faPortrait,
  faUserCog,
  faBold,
  faItalic,
  faUnderline,
  faListUl,
  faListOl,
  faRedo,
  faUndo,
  faGripLines,
  faParagraph,
  faTags,
  faThList,
  faDog,
  faUtensils,
  faVolleyballBall,
  faPlaneDeparture,
  faIcons,
  faEye,
  faTshirt,
  faSearch,
  faFunnelDollar,
  faCheck,
  faTimes,
  faStar,
  faSpider,
  faArchive,
  faBriefcase,
  faUserSecret,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCircle,
  faFlag,
  faFileImage,
  faBuilding,
  faGrinAlt,
  faSmile,
  faLightbulb,
} from '@fortawesome/free-regular-svg-icons'

// import {
//   faGoogle
// } from '@fortawesome/free-brands-svg-icons'

// Add selected icons to fontawesome
library.add(
  faCircle,
  faGift,
  faFlag,
  faTachometerAlt,
  faUserEdit,
  faEdit,
  faList,
  faBookOpen,
  faUpload,
  faCog,
  faLink,
  faFileImage,
  faCamera,
  faFileAlt,
  faExpandArrowsAlt,
  faArrowsAlt,
  faExternalLinkAlt,
  faAngleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faStore,
  faBuilding,
  faHistory,
  faEnvelope,
  faMoneyBill,
  faHeartbeat,
  faDatabase,
  faShoppingCart,
  faDownload,
  faHome,
  faLayerGroup,
  faFire,
  faPoll,
  faImages,
  faPortrait,
  faUserCog,
  faBold,
  faItalic,
  faUnderline,
  faListUl,
  faListOl,
  faRedo,
  faUndo,
  faGripLines,
  faParagraph,
  faTags,
  faThList,
  faGrinAlt,
  faSmile,
  faDog,
  faUtensils,
  faVolleyballBall,
  faPlaneDeparture,
  faLightbulb,
  faFlag,
  faIcons,
  faEye,
  faTshirt,
  faSearch,
  faFunnelDollar,
  faCheck,
  faTimes,
  faStar,
  faSpider,
  faArchive,
  faBriefcase,
  faUserSecret,
)

// Register component
Vue.component('font-awesome-icon', FontAwesomeIcon)
